import React from 'react';
import { Navigate } from 'react-router-dom';

const AuthRoute = ({ children }: { children: JSX.Element }) => {
    const accessToken = localStorage.getItem('accessToken');
    return accessToken ? <Navigate to="/certification" /> : children;
};

export default AuthRoute;
